export default __webpack_public_path__ + "static/media/karen-klaus.d5cc3b56.png";